import { defineMessages } from 'react-intl'

export default defineMessages({
  addVisit: {
    id: 'common.visitModal.add',
    defaultMessage: 'Add visit for {patientName}'
  },
  editVisit: {
    id: 'common.visitModal.edit',
    defaultMessage: 'Edit visit for {patientName}'
  },
  visitUpdated: {
    id: 'visitForm.visitUpdated',
    defaultMessage: 'Visit updated.'
  },
  visitCreated: {
    id: 'visitForm.visitCreated',
    defaultMessage: 'Visit created.'
  },
  close: {
    id: 'visitForm.close',
    defaultMessage: 'Close'
  },
  save: {
    id: 'visitForm.save',
    defaultMessage: 'Save'
  }
})
